import { LineReveal, Reveal } from "@/components/site/motion";
import { Eyebrow } from "@/components/site/SectionHead";
import { ClipFrame } from "@/components/site/ClipFrame";

export const PageHero = ({ eyebrow, lines, text, image, imageCaption, titleClass, children, testId }) => (
  <section className="relative overflow-hidden pb-20 pt-32 sm:pb-28 sm:pt-44" data-testid={testId}>
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_50%_at_80%_10%,rgba(0,242,254,0.06),transparent_70%)]" />
    <div className="shell relative grid items-end gap-12 lg:grid-cols-12">
      <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
        <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
        <LineReveal
          as="h1"
          play
          delay={0.1}
          lines={lines}
          className={titleClass || "mt-6 text-[13vw] font-[560] leading-[0.92] tracking-[-0.05em] text-fg sm:text-7xl lg:text-[6.2rem] xl:text-[7rem]"}
          testId="page-title"
        />
        {text && (
          <Reveal delay={0.35}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-fg-2 sm:text-xl">{text}</p>
          </Reveal>
        )}
        {children}
      </div>
      {image && (
        <ClipFrame src={image} caption={imageCaption} className="aspect-[16/11] lg:col-span-5 lg:aspect-[4/5]" imgClass="grayscale-[40%]" />
      )}
    </div>
  </section>
);
